(() => {
  const anchors = () => {
    document.querySelectorAll('[data-lyma-newsletter-anchor]').forEach((anchor, index) => {
      if (index === 0) anchor.id = 'nieuwsbrief';
      else if (anchor.id === 'nieuwsbrief') anchor.removeAttribute('id');
    });
  };
  anchors();
  document.addEventListener('shopify:section:load', anchors);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(anchors));
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-lyma-discount-tab]');
    if (!tab || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const newsletter = document.getElementById('nieuwsbrief');
    if (!newsletter) return; // Follow the localized homepage + anchor link.
    event.preventDefault();
    newsletter.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
    newsletter.setAttribute('tabindex', '-1');
    newsletter.focus({ preventScroll: true });
  });
})();
